<template>
  <MainLogin title="Recuperar contraseña">
    <div v-if="!loading">
      <b-form-group
        :class="{feedback : errors.has('codigo_usuario_incorrecto')}"
        label="Código de usuario"
        label-for="email">
        <b-form-input
          type="text"
          name="email"
          id="email"
          v-on:change="clear"
          v-model="item.email">
        </b-form-input>
        <transition name="slide-down">
          <p v-show="errors.has('codigo_usuario_incorrecto')" class="alert alert-danger feedback-message">
            {{ errors.first('codigo_usuario_incorrecto') }}
          </p>
        </transition>
        <transition name="slide-down">
          <p v-show="errors.has('bot')" class="alert alert-danger feedback-message">
            {{ errors.first('bot') }}
          </p>
        </transition>
      </b-form-group>

      <b-alert
        variant="success"
        v-if="sentSuccess"
        show>
        {{ info }}
      </b-alert>

      <b-row>
        <b-col>
          <div>
            <Recaptcha v-if="!logged" @validate="validate"/>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col lg="5">
          <b-btn
            block
            :disabled="!this.validateRecaptcha"
            id="reset-button"
            variant="primary"
            @click="reset">
            Recuperar contraseña <i v-if="this.validateRecaptcha" class="fa fa-sign-in"></i><i v-if="!this.validateRecaptcha" class="fa fa-lock"></i>
          </b-btn>
        </b-col>
        <b-col lg="7" class="text-right">
          <b-link
            id="login-button"
            @click="backlogin">
            Regresar
          </b-link>
        </b-col>
      </b-row>
    </div>
    <div v-else class="card-body text-center">
      <p><i class="fa fa-spinner fa-spin fa-3x"></i></p>
      <p>Enviando email</p>
    </div>
  </MainLogin>
</template>

<script>

import MainLogin from './MainLogin';
import Recaptcha from './Recaptcha';
import RecaptchaUtils from '../../utils/recaptcha.utils';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'EmailResetPwd',
  components: {
    MainLogin,
    Recaptcha
  },
  data: function () {
    return {
      loading: false,
      sentSuccess: false,
      variant: '',
      item: {
        email: ''
      },
      info: '',
      validateRecaptcha: false,
      logged: false
    };
  },
  methods: {
    clear () {
      this.sentSuccess = false;
    },
    recaptcha: function () {
      RecaptchaUtils.checkRecaptcha.bind(this)('reset_password').then(validRecaptcha => {
        if (validRecaptcha) {
          this.reset();
        } else {
          this.errors.add('bot', 'No se cumplen los requisitos para recuperar la contraseña');
        }
      }, reason => {
        this.errors.add('bot', 'Error validando recaptcha');
      });
    },
    validate (success) {
      this.validateRecaptcha = success;
      this.logged = true;
    },
    reset () {
      this.loading = true;
      this.$http.post('auth_custom/password/reset/', this.item).then(response => {
        this.loading = false;
        this.showAlert = true;
        this.info = 'Por favor revise su bandeja de entrada, se le ha enviado un correo para restaurar su contraseña';
        this.sentSuccess = true;
        this.errors.clear();
      }).catch(response => {
        if (response.status === 400) {
          this.loading = false;
          this.errors.add('codigo_usuario_incorrecto', 'No se ha podido enviar el correo para restaurar su contraseña. Por favor revise el código de usuario, y vuelva a intentarlo.');
        }
      });
    },
    backlogin () {
      this.$router.push({name: 'Login'});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Login/EmailResetPwd.vue